import React, { useEffect, useState } from 'react'

function CounterDown({
  showDays,
  showHours,
  showMins,
  showSegs,
}) {
  const [counterDays, setCounterDays] = useState(0)
  const [counterHours, setCounterHours] = useState(0)
  const [counterMins, setCounterMins] = useState(0)
  const [counterSegs, setCounterSegs] = useState(0)
  const [end, setEnd] = useState(false)
  
  useEffect(() => {
      const countDownDate = new Date('2025-08-15 23:59:59').getTime()

      const startCountdown = () => {
        const timer = setInterval(function() {
          let now = new Date().getTime();
          let distance = countDownDate - now;
            
          if (distance < 0) {
            setEnd(true)
            clearInterval(timer)
          }

          let days = Math.floor(distance / (1000 * 60 * 60 * 24));
          let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
          setCounterDays(days)
          setCounterHours(hours)
          setCounterMins(minutes)
          setCounterSegs(seconds)
        }, 1000)
      }
      startCountdown()
    
  }, [])

  return (
    <div className={`mc-counter-down`}>
      <div>
         <div id="countdown">
          {end
            ? <>El contador finalizó</>
            : <div className='mc-counter-down-container type_2'>
                  <div className='mc-counter-down-container'>
                    <h6>Te queda</h6>
                    <ul>
                      {showDays && <><li><span id="days">{counterDays}</span><hr/>Días</li><span className='separador'>:</span></>}
                      {showHours && <><li><span id="hours">{counterHours}</span><hr/>Horas</li><span className='separador'>:</span></>}
                      {showMins && <><li><span id="minutes">{counterMins}</span><hr/>Minutos</li><span className='separador'>:</span></>}
                      {showSegs && <li><span id="seconds">{counterSegs}</span><hr/>Segundos</li>}
                    </ul>
                  </div>
                  <span className='terms_text'>para redimir el bono que ganaste. ¡Hazlo ya!</span>
                </div>
          }
          
        </div>
        
      </div>
    </div>
  )
}

export default CounterDown